import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material';

export const MuiTableCell: {
    defaultProps?: ComponentsProps['MuiTableCell'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiTableCell'];
    variants?: ComponentsVariants['MuiTableCell'];
} = {
    defaultProps: {},
    styleOverrides: {
        root: (props) => [
            {
                ...props.theme.typography.body1,
                padding: props.theme.spacing(props.theme.tokens.spacing.md),
                borderBlockEndColor: props.theme.palette.divider,
            },
        ],
        head: [{ fontWeight: 'bold' }],
    },
    variants: [],
};
